import React from "react";
import { Card, CardContent } from "@mui/material";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import MetaAdsPanel from "./MetaAdsPanel";

const money = value => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const number = value => Number(value || 0).toLocaleString("pt-BR");
const box = { border: "1px solid #dfe4e1", borderRadius: 16, boxShadow: "none" };

function Metric({ label, value }) {
  return <Card style={box}><CardContent><small style={{ color: "#77857d", letterSpacing: ".12em" }}>{label.toUpperCase()}</small>
    <div style={{ fontSize: 27, fontWeight: 800, marginTop: 6 }}>{value}</div></CardContent></Card>;
}

export default function MetaAdsDashboard({ data = {}, isAdmin, dateFrom, dateTo, onChanged }) {
  const ctr = data.impressions ? Number(data.clicks) * 100 / Number(data.impressions) : 0;
  const cpl = data.leads ? Number(data.spend) / Number(data.leads) : 0;
  const grid = { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 10 };
  return <div style={{ display: "grid", gap: 10 }}>
    <div style={grid}>
      <Metric label="Investimento" value={money(data.spend)} />
      <Metric label="Alcance estimado" value={number(data.reach)} />
      <Metric label="CPL médio" value={money(cpl)} />
      <Metric label="CTR médio" value={`${ctr.toFixed(2)}%`} />
      <Metric label="Leads no período" value={number(data.leads)} />
      <Metric label="Campanhas" value={number(data.campaigns)} />
    </div>
    <div style={grid}>
      <Card style={box}><CardContent><h2 style={{ fontSize: 16, marginTop: 0 }}>Gasto diário × leads</h2>
        {data.daily?.length ? <div style={{ width: "100%", height: 250 }}><ResponsiveContainer>
          <LineChart data={data.daily}><CartesianGrid strokeDasharray="2 4"/><XAxis dataKey="date" tick={{fontSize:9}}/>
            <YAxis tick={{fontSize:9}}/><Tooltip/><Line dataKey="spend" stroke="#078a59" strokeWidth={2} dot={false}/>
            <Line dataKey="leads" stroke="#c7a14c" strokeWidth={2} dot={false}/></LineChart>
        </ResponsiveContainer></div> : <p>Sem dados de anúncios no período.</p>}</CardContent></Card>
      <Card style={box}><CardContent><h2 style={{ fontSize: 16, marginTop: 0 }}>Hierarquia de campanhas</h2>
        {data.hierarchy?.length ? data.hierarchy.map(campaign => <div key={campaign.campaignId || campaign.name} style={{ padding: "9px 0", borderTop: "1px solid #edf0ed" }}>
          <strong>{campaign.name || campaign.campaignId}</strong><small style={{ display: "block", color: "#78857e" }}>
            {campaign.adsets} conjuntos · {campaign.ads} anúncios · {money(campaign.spend)} · {campaign.leads} leads
          </small></div>) : <p>Nenhuma campanha com entrega no período.</p>}
      </CardContent></Card>
    </div>
    <MetaAdsPanel isAdmin={isAdmin} dateFrom={dateFrom} dateTo={dateTo} onChanged={onChanged} />
  </div>;
}
